export default __webpack_public_path__ + "static/media/regata2.f1465696.jpg";